import React from "react";
import classnames from "classnames";
import { getShimmerClass } from "utils/constants/ui";

const SectionNavLoader = ({ withShimmer }) => {
  const shimmerClass = getShimmerClass(withShimmer);

  return (
    <div className="dn db-ns h-100 w3 pt3 bg-white bh--inset ph3">
      <div className="flex flex-column items-center">
        {new Array(4).fill("").map((_, stubIx) => (
          <div
            key={stubIx}
            className={classnames(`h2 w-100 ${shimmerClass}`, {
              mt2: stubIx
            })}
          ></div>
        ))}
      </div>
    </div>
  );
};
export default SectionNavLoader;
